import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useCustomHeader = () => {
  const page = useSelector(select.cms.getPage);

  return {
    lightHeader: page?.custom_header === 'light' || !!page?.light_header,
    prospectHeader: page?.custom_header === 'prospect',
    clickableLogoUrl: page?.clickable_logo_url,
    headerLink: page?.content[0]?.header_link
  };
};

export default useCustomHeader;
